import {createGtm} from "@gtm-support/vue-gtm";

export default defineNuxtPlugin(({vueApp}) => {
  const {gtm: {id}} = useAppConfig();

  vueApp.use(createGtm({
    id,
    defer: true,
    vueRouter: useRouter(),
    enabled: true
  }));
});
